import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberLocalize'
})
export class NumberLocalizePipe implements PipeTransform {

  transform(input: any, isCurrency: boolean = null): any {
    if (input == 0)
                return 0;
            if (input != 0 && (input == null || input == ''))
                return '';
            if (isNaN(input)) {
                return input;
            }

            //Set a default value for isCurrency if a value is not given.
            //  Can't do this in the parameter definitions, as IE doesn't support default parameters. Not even on a basic level.
            if (isCurrency == null)
                isCurrency = false;

            //Initial split on decimal
            var decimalSplit = input.toString().split('.');

            //Format helper vars
            var threeCount = 0;
            var wholeFormat = [];

            var symbolGroupNumber = CVNumberGroupingSymbol,
                symbolGroupCurrency = CVCurrencyGroupingSymbol,
                symbolDecimal = CVDecimalSymbol;

            //Do the format
            decimalSplit[0].split('').reverse().forEach(function (c) {
                threeCount += 1;
                wholeFormat.push(c);

                if (threeCount >= 3) {
                    threeCount = 0;

                    if (isCurrency)
                        wholeFormat.push(symbolGroupCurrency);
                    else
                        wholeFormat.push(symbolGroupNumber);
                }
            });

            //Check for dangling group symbols (',123.01' => '123.01')
            if (wholeFormat[wholeFormat.length - 1] == symbolGroupNumber || wholeFormat[wholeFormat.length - 1] == symbolGroupCurrency) {
                wholeFormat.pop();
            }

            //Final touches
            var result = wholeFormat.reverse().join('');
            if (decimalSplit[1] != null) {
                result = ''.concat(result, symbolDecimal, decimalSplit[1]);
            }

            return result;
  }

}
